import client from './client';

// Function to get and download Paycor file as a .zip
export const getPaycorFile = async (payPeriodID: string | number) => {
    try {
        // Make the API request to fetch the Paycor file
        const response = await client.get(`/admin/paycor/getPaycorFile?payPeriodID=${payPeriodID}`, {
            responseType: 'blob' // Important: Set responseType to blob to handle file download
        });

        // Log the response data to the console
        console.log("Paycor file downloaded successfully:", response.data);

        // Create a blob URL for the downloaded file
        const blob = new Blob([response.data], { type: 'application/zip' });
        const url = window.URL.createObjectURL(blob);

        // Create a temporary link element to trigger the download
        const link = document.createElement('a');
        link.href = url;
        link.download = `paycor-file-${payPeriodID}.zip`; // Set the filename for download
        document.body.appendChild(link);
        link.click();

        // Clean up: remove the link and revoke the blob URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        return response;

    } catch (error) {
        // Log any errors that occur during the download process
        console.error("Error downloading Paycor file:", error);

        // Throw an error to indicate that downloading the file failed
        throw new Error("Failed to download Paycor file");
    }
};

// Function to get and download Paycor PRDA Local file as a .xlsx
export const getPaycorPrdaLocalFile = async (payPeriodID: string | number, year: string, week: number) => {
    try {
        // Make the API request to fetch the Paycor PRDA Local file
        const response = await client.get(`/admin/paycor/getPrdaLocalFile?payPeriodID=${payPeriodID}`, {
            responseType: 'blob' // Important: Set responseType to blob to handle file download
        });

        // Log the response data to the console
        console.log("Paycor PRDA Local file downloaded successfully:", response.data);

        // Create a blob URL for the downloaded file
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);

        // Create a temporary link element to trigger the download
        const link = document.createElement('a');
        link.href = url;
        link.download = `PaycorPRDALocal-${year}-Week${week}.xlsx`; // Set the filename for download
        document.body.appendChild(link);
        link.click();

        // Clean up: remove the link and revoke the blob URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        return response;

    } catch (error) {
        // Log any errors that occur during the download process
        console.error("Error downloading Paycor PRDA Local file:", error);

        // Throw an error to indicate that downloading the file failed
        throw new Error("Failed to download Paycor PRDA Local file");
    }
};